// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------
// /assets/icons/navbar/${name}.svg
const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const PRProduction = [
  {
    title: 'Style Rate Card',
    path: '/dashboard/manage/style_rate_card',
    icon: icon('src'),
    ShortName: 'Transaction_StyleRateCard',
  },
  {
    title: 'SRC Approval',
    path: '/dashboard/manage/style_rate_card_approve/manage',
    icon: icon('appr'),
    ShortName: 'Transaction_SRCApproval',
  },
  {
    title: 'PR Production',
    path: '/dashboard/manage/pr_production',
    icon: icon('production'),
    ShortName: 'Transaction_PRProduction',
  },
  // {
  //   title: 'Production Report Card',
  //   path: '/dashboard/reports/pr_production',
  //   icon: icon('reportpr'),
  //   ShortName: 'Reports_ProductionReportCard',
  // },
  // {
  //   title: 'Production Hrs Wise',
  //   path: '/dashboard/reports/pr_production_hourly',
  //   icon: icon('hourly'),
  //   ShortName: 'Reports_ProductionHrsWise',
  // },
  // {
  //   title: 'PR Skill Matrix',
  //   path: '/dashboard/reports/pr_skillmatrix',
  //   icon: icon('skills'),
  //   ShortName: 'Reports_SkillMatrixPR',
  // },
];

export default PRProduction;
